import {Item} from '../types/Item';

export const items: Item[] = [
    { date: new Date(2025, 3, 1), category: 'food', title: 'McDonalds', value: 32.12 },
    { date: new Date(2025, 3, 2), category: 'food', title: 'Burger King', value: 28 },
    { date: new Date(2025, 3, 3), category: 'rent', title: 'Aluguel', value: 2300 },
    { date: new Date(2025, 4, 4), category: 'salary', title: 'Salário', value: 4500 }
];